import { createSelector } from 'reselect';

// --- Selectors --- //
import scheduleFacilityViewStateSelector from 'store/selectors/scheduleSelectors/scheduleFacilityViewStateSelector';

const isPositionShiftsEnableSelector = createSelector(
  scheduleFacilityViewStateSelector,
  (facilityViewState) => !!facilityViewState.isShowPositionShiftsEnabled,
);

export default isPositionShiftsEnableSelector;
